(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ParticleConnectReactUI", ["React"], factory);
	else if(typeof exports === 'object')
		exports["ParticleConnectReactUI"] = factory(require("react"));
	else
		root["ParticleConnectReactUI"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__4__) => {
return 